import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import Hero from "../components/Hero";
import Slices from "../slices";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function ProductsPage(props) {
  const dispatch = useDispatch();

  const [extraClass, setExtraClass] = useState(false);

  const directLink = props.location.directLink;

  const pageLoading = useSelector((state) =>
    get(state, "prismic.products_page.loading", true)
  );
  const page = useSelector((state) =>
    get(state, "prismic.products_page.data", false)
  );

  const richContent = get(page, "hero_section[0].rich_content");
  const buttons = get(page, "buttons");
  const backgroundColor = get(page, "hero_section[0].background_color");
  const backgroundImage = get(page, "hero_section[0].background_image.url");
  const mobileBackgroundImage = get(
    page,
    "hero_section[0].mobile_background_image.url"
  );
  const sectionAlignment = get(page, "hero_section[0].section_alignment");
  const showGlobalSlices = get(page, "global_slices");

  const slices = get(page, "body");

  const globalSlices = useSelector((state) =>
    get(state, "prismic.global_slices.data.body")
  );

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_SINGLE_PAGE",
      key: "products_page",
    });
    dispatch({
      type: "PRISMIC_LOAD_SINGLE_PAGE",
      key: "global_slices",
    });
  }, [dispatch]);

  useEffect(() => {
    setExtraClass(false);
    setTimeout(() => {
      setExtraClass("yas");
    }, 200);
  }, [pageLoading]);

  if (pageLoading) {
    return (
      <CircularProgress
        style={{
          position: "fixed",
          color: "white",
          top: "calc(50% - 25px)",
          left: "calc(50% - 25px)",
          width: "50px",
          height: "50px",
        }}
      />
    );
  }

  return (
    !pageLoading &&
    page && (
      <div className={`animation ${extraClass && extraClass}`}>
        <Hero
          richContent={richContent}
          sectionAlignment={sectionAlignment}
          backgroundColor={backgroundColor}
          buttons={buttons}
          backgroundImage={backgroundImage}
          mobileBackgroundImage={mobileBackgroundImage}
        />

        <Slices slices={slices} directLink={directLink} />
        {showGlobalSlices && globalSlices && <Slices slices={globalSlices} />}
      </div>
    )
  );
}
